import React from 'react'
import { BiMap, BiPhone} from 'react-icons/bi'
import { BsWhatsapp, BsYoutube } from 'react-icons/bs'
import { CgMail } from 'react-icons/cg'
import { FaFacebook } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const FooterContent = () => {

  const phoneNumber = '916387355032';
  const message = 'Hello! Quick question.';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  return (
    <>
      <footer class="space-pt bg-overlay-black-90 bg-holder footer mt-n5" style={{ backgroundImage: `url(images/banner/slide-7.png)` }}>
      <div class="container pt-0">
        <div class="row pb-0 pb-lg-6 mb-lg-3">
          <div class="col-sm-6 col-lg-4 mb-4 mb-lg-0 pr-lg-5">
           
            <p class="text-white">In the year 1963, Prof. Puran Singh, a true Pioneer and visionary, gave shape to his dream of educating the upcoming generations. Our Manager Sir's dedication and passion led to the establishment of the first ever branch of Pioneer Montessori Schools in Rajendra Nagar in the year 1963.</p>
            <h5 class="text-white mb-2 mb-sm-4">Follow Us</h5>
            <div class="social-icon social-icon-style-02">
              <ul>
                <li><Link to={'https://www.facebook.com/pmiceldeco'} target="_blank"><FaFacebook /></Link></li>
                {/* <li><Link to={'#'}><BiX /></Link></li> */}
                <li><Link to={'https://www.youtube.com/@PioneerMontessoriInterCollege'} target="_blank"><BsYoutube /></Link></li>
                {/* <li><Link to={'#'}><ImInstagram /></Link></li> */}
              </ul>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2 mb-4 mb-lg-0">
            <h5 class="text-white mb-2 mb-sm-4">Useful Link</h5>
            <div class="footer-link">
              <ul class="list-unstyled mb-0">
                <li><Link class="text-white" to={'/About'}>About Pioneer</Link></li>
                <li><Link class="text-white" to={'/FeeStructure'}>Fee Structure</Link></li>
                <li><Link class="text-white" to={'/AdmissionProcedure'}>Admission Procedure</Link></li>
                <li><Link class="text-white" to={'/StudentCouncil'}>Student Council</Link></li>
                <li><Link class="text-white" to={'/Prospectus'}>Prospectus</Link></li>              
              </ul>
            </div>
          </div>
          <div class="col-sm-6 col-lg-2 mb-4 mb-sm-0">
            <h5 class="text-white mb-2 mb-sm-4">Useful Link</h5>
            <div class="footer-link">
              <ul class="list-unstyled mb-0">
                <li><Link class="text-white" to={'/Vision'}>Vision & Mission</Link></li>
                <li><Link class="text-white" to={'/Branches'}>Our Branches</Link></li>               
                <li><Link class="text-white" to={'/PhotoGallery'}>Our Gallery</Link></li>
                <li><Link class="text-white" to={'/Manager'}>Our Management</Link></li>
                <li><Link class="text-white" to={'/OurAchievements'}>Achievements</Link></li>
              </ul>
            </div>
          </div>
          <div class="col-sm-6 col-lg-4">
            <h5 class="text-white mb-2 mb-sm-4">Contact Us</h5>
            {/* <p class="text-white">Helped thousands of clients to find the right property for their needs.</p> */}
            <div class="footer-contact-info">
              <div class="contact-address mt-4">
                <div class="contact-item d-flex align-items-start gap-2">
                  <BiMap size={'40'} className='text-white' />
                  <p class="ml-3 mb-0 text-white">Sector- 3, Udyan 1, Eldeco Colony, Near Bangla Bazar, Lucknow 226002</p>
                </div>
                <div class="contact-item d-flex align-items-center gap-2">
                   <BsWhatsapp size={'24'} className='text-white' />
                  <p class="mb-0 font-weight-bold ml-3"><Link class="text-white" onClick={handleWhatsAppClick}>+91 6387355032</Link></p>
                </div>
                <div class="contact-item d-flex align-items-center gap-2">
                   <BiPhone size={'24'} className='text-white' />
                  <p class="mb-0 font-weight-bold ml-3"><a class="text-white" href="tel:+91(0522)4232799">+91 (0522) 4232799</a></p>
                </div>
                
                <div class="contact-item d-flex align-items-center gap-2">
                  <CgMail size={'20'} className='text-white' />
                  <a class="text-white ml-3 text-white" href="mailto:pmseldeco@rediffmail.com">pmseldeco@rediffmail.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom bg-dark py-4">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-12 text-center">
              <p class="mb-0 text-white">© Pioneer Montessori Inter College Lucknow | Powered by <Link to={'https://adventusindia.com/'} target='_blank'>Adventus</Link></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    </>
  )
}

export default FooterContent
